import { FC } from "react";
import { useTranslation } from "react-i18next";
import {
  NameFormContainer,
  NextButton,
  Prompt,
  QuestionContainer,
  QuestionPageContainer,
} from "~/OnboardingApp/components";
import { InputSection } from "./components";

export const NamePage: FC = () => {
  const { t } = useTranslation();

  return (
    <QuestionPageContainer>
      <NameFormContainer>
        <QuestionContainer>
          <Prompt question={t("onboarding.namePage.question")} />

          <InputSection />
        </QuestionContainer>

        <NextButton />
      </NameFormContainer>
    </QuestionPageContainer>
  );
};
